<template>
  <div style="height: 100%">
    <header-box />
    <div class="login-body">
      <img class="login-icon1" src="@/assets/img/login-icon2.png" />
      <img class="login-icon2" src="@/assets/img/login-icon3.png" />
      <div>
        <div class="login-desc">
          <p>数字经济应用场景创新平台</p>
          <div>
            依托解放号软件产业互联网生态体系和数、智、码、聚产品服务矩阵<br />伴行政府全域数字经济创新发展需要，快速启动以应用场景开放为切入完<br />成全过程线上线下服务包渗透
          </div>
          <img src="@/assets/img/loginicon.png" />
        </div>
        <div class="login-from-body">
          <div class="login-type">
            <span :class="{ active: loginType == 0 }" @click="loginType = 0"
              >账号密码登录</span
            >
            <span :class="{ active: loginType == 1 }" @click="loginType = 1"
              >手机验证登录</span
            >
          </div>
          <div class="login-from-content">
            <div>
              <template v-if="loginType == 0">
                <div class="login-from-input">
                  <a-input
                    size="large"
                    v-model="userName"
                    placeholder="手机号/邮箱"
                  >
                    <a-icon slot="prefix" type="user" />
                  </a-input>
                </div>
                <div class="login-from-input">
                  <a-input
                    size="large"
                    :type="inputPassword == 'eye' ? 'text' : 'password'"
                    v-model="userPassword"
                    placeholder="请输入密码"
                  >
                    <a-icon slot="prefix" type="unlock" />
                    <a-icon
                      slot="suffix"
                      :type="inputPassword"
                      style="cursor: pointer"
                      @click="inputPasswordType(inputPassword)"
                    />
                  </a-input>
                </div>
              </template>
              <template v-else>
                <div class="login-from-input">
                  <a-input
                    size="large"
                    v-model="userPhone"
                    placeholder="请输入手机号"
                  >
                    <a-icon slot="prefix" type="user" />
                  </a-input>
                </div>
                <div class="login-from-code">
                  <a-input
                    size="large"
                    style="width: 224px"
                    v-model="graphCode"
                    placeholder="请输入图形校验码"
                  >
                    <a-icon slot="prefix" type="safety-certificate" />
                  </a-input>
                  <div @click="refreshCode">
                    <verification :identifyCode="identifyCode" />
                  </div>
                </div>
                <div class="login-from-code" style="margin-bottom: 0">
                  <a-input
                    size="large"
                    style="width: 224px"
                    v-model="phoneCode"
                    placeholder="请输入验证码"
                  >
                    <a-icon slot="prefix" type="safety-certificate" />
                  </a-input>
                  <a-button
                    @click="obtainSmsCode"
                    :disabled="phoneCodeBtn"
                    :class="{ 'btn-gray': phoneCodeBtn }"
                  >
                    {{
                      phoneCodeBtn
                        ? reciprocalNum + "秒后重新发送"
                        : "获取验证码"
                    }}
                  </a-button>
                </div>
              </template>
              <a-button @click="login">登 录</a-button>
              <div class="login-from-footer">
                <a-checkbox style="visibility: hidden" v-model="checkbox"
                  >记住登录状态
                </a-checkbox>
                <div>
                  <span @click="registered">账号申请</span>
                  <span @click="forgetPassword">忘记密码</span>
                </div>
              </div>
            </div>
            <!--            <p class="login-tishi">温馨提示：解放号账号可与场景开放平台通用</p>-->
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer-body">
      <div>
        <div class="before-footer-contact-body">
          <div class="before-footer-contact-detail">
            <p>
              <a-icon type="phone" theme="filled" />
              <strong>{{ settings.SUPPORT_PHONE }}</strong>
            </p>
            <p>
              <a-icon type="mail" theme="filled" />
              <span>{{ settings.SUPPORT_EMAIL }}</span>
            </p>
          </div>
          <div class="before-footer-contact-url">
            <span>友情链接</span>
            <a
              v-for="(el, index) in links"
              :key="index"
              :href="el.href"
              target="_blank"
              >{{ el.name }}
            </a>
          </div>
        </div>
        <div class="before-footer-text">
          <span>主办单位：{{ settings.ORGANIZER }}</span>
          <span>技术支持：{{ settings.TECHNICAL_SUPPORT }}</span>
          <span>{{ settings.ICP_NUMBER }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import verification from "../components/verification.vue";
import headerBox from "../beforeLayout/header.vue";
import $ from "jquery";
import "jquery.cookie";
import { registerSmsCode } from "@/api/login";
import { getLinkList } from "@/api/settting";
import { mapGetters } from "vuex";

export default {
  components: {
    verification,
    headerBox,
  },
  data() {
    return {
      loginType: 0, //0账号密码登录，1手机验证码登录
      userName: "",
      userPassword: "",
      inputPassword: "eye-invisible",
      userPhone: "",
      graphCode: "",
      phoneCode: "",
      identifyCodes: "0123456789qwerasdfzxcv",
      identifyCode: "",
      checkbox: false,
      reciprocalNum: 60,
      phoneCodeBtn: false,
      links: [],
    };
  },
  computed: mapGetters(["settings"]),
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    this.loadLinks();
  },
  methods: {
    loadLinks() {
      getLinkList().then((res) => {
        this.links = res.data;
      });
    },
    // 获取手机验证码
    obtainSmsCode() {
      let _this = this;
      if (!_this.userPhone) {
        _this.$message.warning("* 手机号不能为空.");
        return;
      }
      if (_this.userPhone.length != 11) {
        _this.$message.warning("* 手机号输入有误.");
        return;
      }
      if (_this.identifyCode != _this.graphCode) {
        _this.$message.warning("* 图形验证码输入有误.");
        return;
      }
      this.phoneCodeBtn = true;
      let data = {
        mobile: _this.userPhone,
        userCountry: "86",
        captchaType: "login",
      };
      registerSmsCode(data).then((res) => {
        this.$message.success("发送成功!");
        this.reciprocalItme();
      });
    },
    reciprocalItme() {
      let _this = this;
      let num = this.reciprocalNum;
      let itme = null;
      itme = setInterval(function () {
        num--;
        if (num <= 0) {
          _this.phoneCodeBtn = false;
          _this.reciprocalNum = 60;
          clearInterval(itme);
          return;
        }
        _this.reciprocalNum = num;
      }, 1000);
    },
    // 验证码处理
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    // 刷新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      console.log(this.identifyCode);
    },
    inputPasswordType(type) {
      if (type == "eye") {
        this.inputPassword = "eye-invisible";
      } else {
        this.inputPassword = "eye";
      }
    },
    registered() {
      this.$router.push("/registered");
    },
    login() {
      const _this = this;
      if (this.loginType === 0) {
        // 空值验证
        if (!_this.userName || !_this.userPassword) {
          _this.$message.warning("* 用户名或密码不能为空.");
          return;
        }
        // 长度验证
        if (_this.userPassword.length < 5) {
          _this.$message.warning("* 密码长度不足.");
          return;
        }
        const postData = {
          username: _this.userName,
          password: _this.userPassword,
          grant_type: "password",
          scope: "server",
          type: "password",
        };
        // 登录请求
        _this.$store
          .dispatch("Login", postData)
          .then(() => {
            // 是否记录帐号密码
            $.cookie("l", null);
            if (this.checkbox) {
              const l = {
                u: _this.username,
                p: _this.password,
              };
              $.cookie("l", JSON.stringify(l), {
                expires: 7,
              });
            }
            setTimeout(function () {
              _this.$store
                .dispatch("GetInfo")
                .then(() => {})
                .catch(() => {});
            }, 500);
            _this.$router.push("/homeIndex");
          })
          .catch((err) => {
            if (err.error_description === "Bad credentials") {
              this.$message.error("您的账号或密码输入错误，请重新输入！");
            }
          });
      } else {
        if (!_this.userPhone) {
          _this.$message.warning("* 手机号不能为空.");
          return;
        }
        if (_this.userPhone.length != 11) {
          _this.$message.warning("* 手机号输入有误.");
          return;
        }
        if (_this.identifyCode != _this.graphCode) {
          _this.$message.warning("* 图形验证码输入有误.");
          return;
        }
        if (!_this.phoneCode) {
          _this.$message.warning("* 请输入手机验证码.");
          return;
        }
        const postData = {
          username: _this.userPhone,
          code: _this.phoneCode,
          grant_type: "sms",
          scope: "server",
          type: "code",
        };
        _this.$store
          .dispatch("Login", postData)
          .then(() => {
            // 是否记录帐号密码
            $.cookie("l", null);
            if (this.checkbox) {
              const l = {
                u: _this.username,
                p: _this.password,
              };
              $.cookie("l", JSON.stringify(l), {
                expires: 7,
              });
            }
            setTimeout(function () {
              _this.$store
                .dispatch("GetInfo")
                .then(() => {})
                .catch(() => {});
            }, 500);
            _this.$router.push("/homeIndex");
          })
          // .catch(() => {
          //   this.$message.error("验证码输入有误，请重新输入！");
          // });
      }
    },
    forgetPassword() {
      this.$router.push(`/resetPassword`);
      // window.open(`${process.env.VUE_APP_JFH_SERVER}/resetPassword`);
    },
  },
};
</script>

<style lang="less" scoped>
.btn-gray {
  background: gray !important;
  color: #fff !important;
}

.login-body {
  position: relative;
  background: url(../../assets/img/loginbg.jpg) top right no-repeat;
  height: calc(100% - 104px);
  padding-top: 130px;

  .login-icon1 {
    position: absolute;
    display: block;
    top: 92px;
    left: 164px;
  }

  .login-icon2 {
    position: absolute;
    display: block;
    right: 306px;
    bottom: 205px;
  }

  > div {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .login-desc {
      > p {
        font-size: 30px;
        line-height: 30px;
        margin-bottom: 30px;
      }

      > div {
        color: #8c8c8c;
        line-height: 24px;
        font-size: 15px;
      }

      > img {
        max-width: 100%;
        display: block;
        margin-top: 50px;
      }
    }

    .login-from-body {
      position: relative;
      z-index: 2;
      width: 440px;
      padding: 40px 40px 0;
      background: #ffffff;
      box-shadow: 0px 4px 32px 0px rgba(0, 29, 103, 0.08);
      border-radius: 4px;

      .login-type {
        display: flex;
        border-bottom: 1px solid #f0f0f0;

        > span {
          flex: 1;
          height: 64px;
          line-height: 64px;
          border-bottom: 2px solid transparent;
          text-align: center;
          cursor: pointer;
          font-size: 16px;
          transition: all 0.3s;

          &.active {
            border-color: #1abc9c;
          }
        }
      }

      .login-from-content {
        > div {
          padding-top: 30px;
          height: 350px;

          .login-from-input {
            margin-bottom: 24px;
          }

          .login-from-code {
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;

            > button {
              width: 120px;
              height: 40px;
              background: #ffffff;
              border: 1px solid #d9d9d9;
              border-radius: 2px;
              color: #1abc9c;
            }
          }

          > button {
            width: 100%;
            height: 40px;
            background: #1abc9c;
            border-radius: 2px;
            border-color: #1abc9c;
            color: #fff;
            margin-top: 40px;
          }

          .login-from-footer {
            display: flex;
            margin-top: 24px;
            justify-content: space-between;
            color: #595959;

            > div {
              display: flex;

              > span {
                margin-left: 24px;
                cursor: pointer;
              }
            }
          }
        }
      }

      .login-tishi {
        height: 64px;
        border-top: 1px solid #f0f0f0;
        line-height: 64px;
        color: #bfbfbf;
        font-size: 12px;
        text-align: center;
      }
    }
  }
}

.login-footer-body {
  background: #1e1f23;
  // position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  > div {
    width: 1200px;
    margin: 0 auto;

    .before-footer-nav {
      display: flex;

      > span {
        line-height: 12px;
        font-size: 12px;
        cursor: pointer;
        margin-right: 10px;
        padding-right: 10px;
        border-right: 1px solid #999;

        &:last-child {
          margin-right: 0;
          border: 0;
        }
      }
    }

    .before-footer-copyright {
      display: flex;

      > p {
        font-size: 12px;
        font-size: 12px;
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.before-footer-contact-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  > div {
    display: flex;
    align-items: center;
  }

  .before-footer-contact-detail {
    > p {
      margin-right: 30px;
      display: flex;
      align-items: center;

      > i {
        font-size: 18px;
        margin-right: 10px;
      }

      > strong {
        font-size: 24px;
        line-height: 24px;
      }

      > span {
        font-size: 16px;
      }
    }
  }

  .before-footer-contact-url {
    display: flex;
    align-items: center;
    font-size: 16px;

    > a {
      color: #fff;
      margin-left: 20px;
    }
  }
}

.before-footer-text {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    margin: 0 10px;
    font-size: 14px;
    color: #8c8c8c;
  }
}
</style>
